export interface WhiteLabelConfig {
  clinicName: string;
  logoUrl: string;
  logoSize: number;
  favicon: string;
  theme: {
    primaryColor: string;
    primaryGlow: string;
    secondaryColor: string;
    accentColor: string;
  };
  font: {
    family: string;
    googleFontUrl: string;
  };
  defaultNotes: string;
  profile: {
    name: string;
    email: string;
    specialty: string;
    phone: string;
  };
}

export const defaultConfig: WhiteLabelConfig = {
  clinicName: "YuMed",
  logoUrl: "",
  logoSize: 48,
  favicon: "/favicon.png",
  theme: {
    primaryColor: "210 84% 47%",     // Medical Blue
    primaryGlow: "210 84% 55%",
    secondaryColor: "215 20% 65%",   // Blue Slate
    accentColor: "160 84% 39%",      // Medical Green
  },
  font: {
    family: "Inter",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap",
  },
  defaultNotes: "• Paciente orientado(a) sobre os cuidados pré e pós-operatórios\n• Exames pré-operatórios solicitados\n• Dúvidas esclarecidas\n• Retorno agendado",
  profile: {
    name: "",
    email: "",
    specialty: "",
    phone: "",
  },
};

export const presetThemes = {
  medical: {
    name: "Medical Blue",
    primaryColor: "220 70% 50%",
    primaryGlow: "220 70% 60%",
    secondaryColor: "260 60% 55%",
    accentColor: "260 50% 95%",
  },
  modern: {
    name: "Modern Purple",
    primaryColor: "270 70% 55%",
    primaryGlow: "270 70% 65%",
    secondaryColor: "310 60% 50%",
    accentColor: "270 50% 95%",
  },
  professional: {
    name: "Professional Green",
    primaryColor: "160 70% 40%",
    primaryGlow: "160 70% 50%",
    secondaryColor: "200 60% 45%",
    accentColor: "160 50% 95%",
  },
  warm: {
    name: "Warm Orange",
    primaryColor: "25 85% 55%",
    primaryGlow: "25 85% 65%",
    secondaryColor: "340 70% 55%",
    accentColor: "25 50% 95%",
  },
};

export const fontPresets = [
  {
    name: "Inter",
    family: "Inter",
    url: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap",
  },
  {
    name: "Poppins",
    family: "Poppins",
    url: "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap",
  },
  {
    name: "Roboto",
    family: "Roboto",
    url: "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap",
  },
  {
    name: "Montserrat",
    family: "Montserrat",
    url: "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap",
  },
  {
    name: "Lato",
    family: "Lato",
    url: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap",
  },
];
